import { useEffect, useState } from "react";
import { Check, ListPlus, Plus } from "lucide-react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { errMsg, http } from "../lib/api";

export const AddToPlaylist = ({ song, className = "", label }) => {
  const [open, setOpen] = useState(false);
  const [lists, setLists] = useState([]);
  useEffect(() => { if (open) http.get("/playlists").then((r) => setLists(r.data)); }, [open]);

  const add = async (pl) => {
    try {
      await http.post(`/playlists/${pl.id}/songs`, { song_id: song.id });
      toast.success(`Pridėta į „${pl.name}“`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const create = async () => {
    const name = window.prompt("Naujo grojaraščio pavadinimas");
    if (!name?.trim()) return;
    const { data } = await http.post("/playlists", { name: name.trim() });
    await add(data);
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button data-testid={`add-to-playlist-${song.id}`} title="Pridėti į grojaraštį" className={className}>
          <ListPlus className="w-4 h-4" />{label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-60 bg-[var(--c-elev)] border-[var(--c-line)]">
        <DropdownMenuLabel className="text-xs text-zinc-400">Pridėti į grojaraštį</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {lists.map((pl) => (
          <DropdownMenuItem key={pl.id} data-testid={`playlist-option-${pl.id}`} onSelect={() => add(pl)} className="cursor-pointer">
            <span className="flex-1 truncate">{pl.name}</span>
            {pl.song_ids.includes(song.id) ? <Check className="w-3.5 h-3.5 text-[var(--c-orange)]" /> : <span className="text-[10px] text-zinc-500">{pl.count}</span>}
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem data-testid="playlist-option-new" onSelect={create} className="cursor-pointer text-[var(--c-orange)]">
          <Plus className="w-3.5 h-3.5 mr-1" />Naujas grojaraštis
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
